import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { formatRupiah } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const APPROVERS = ["Owner", "ROOT OWNER", "Kepala Bengkel", "Finance Manager"];

export const SpkPendingCard = ({ claim, onDone }) => {
  const { user } = useAuth();
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const p = claim.spk_pending;
  if (!p) return null;
  const canDecide = user?.role === "root" || APPROVERS.includes(user?.role_name || "");
  const decide = async (approve) => {
    setBusy(true);
    try {
      await api.post(`/claims/${claim.id}/spk-pending/decide`, { approve, note });
      toast.success(approve ? "Selisih SPK disetujui" : "Pengajuan SPK ditolak");
      onDone?.();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="spk-pending-card" className="mb-3 rounded-lg border-2 border-red-300 bg-red-50 p-3 text-xs">
      <p className="text-sm font-bold text-red-800">SPK {p.kind === "FIX" ? "FIX" : "REVISI"} — MENUNGGU APPROVAL SELISIH</p>
      <p className="mt-1">No. SPK {p.payload?.spk_number} · Total SPK <b>{formatRupiah(p.spk_value)}</b> · Jumlah rincian <b>{formatRupiah(p.lines_total)}</b> · Selisih <b data-testid="spk-pending-diff">{formatRupiah(p.difference)}</b></p>
      <p>Diajukan {p.requested_by} · {String(p.requested_at || "").slice(0, 16).replace("T", " ")} · {(p.corrections || []).length} koreksi manual OCR</p>
      <p className="text-gray-600">Sparepart belum diteruskan ke Partman sampai disetujui Kepala Bengkel / Finance Manager / Owner.</p>
      {canDecide && (
        <div className="mt-2 flex flex-wrap items-center gap-2">
          <Input data-testid="spk-pending-note" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Catatan / alasan (wajib jika tolak)" className="h-9 max-w-sm bg-white" />
          <Button data-testid="spk-pending-approve" disabled={busy} onClick={() => decide(true)} className="h-9 bg-emerald-600 text-white">SETUJUI</Button>
          <Button data-testid="spk-pending-reject" disabled={busy} onClick={() => decide(false)} variant="outline" className="h-9 border-red-400 text-red-700">TOLAK</Button>
        </div>
      )}
    </div>
  );
};
